import { Box, Modal, Tooltip } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../../common/components/divider/CommonDivider";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import { ModalStyle } from "../../../../common/components/modalstyle/ModalStyle";
import {
  getPatientRTFeedPlanByAddmissionId,
  updatePatientRTFeedStatus,
} from "../../../services/diet/dietorder/RTFeedServices";
import {
  errorAlert,
  successAlert,
} from "../../../../common/components/Toasts/CustomToasts";

const ApproveCheckIcon = ({ disabled = false }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? "default" : "pointer",
      }}
    >
      <path
        d="M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM19.79 10.22C19.92 10.79 20 11.39 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C13.58 4 15.04 4.46 16.28 5.25L17.72 3.81C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.81 21.78 9.67 21.4 8.61L19.79 10.22Z"
        fill={disabled ? "#9CA3AF" : "#43AA27"}
      />
    </svg>
  );
};
const RejectIcon = ({ disabled = false }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? "default" : "pointer",
      }}
    >
      <path
        d="M14.8284 14.8284L9.17158 9.17158M9.17157 14.8284L14.8284 9.17158M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={disabled ? "#9CA3AF" : "#FF0000"} // gray-400 : red
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
function RTFeedPatientChartModal(props) {
  const {
    openRtFeedPatientModal,
    setOpenRtFeedPatientModal,
    selectedRow,
    displayInfo,
    setSelectedRow,
    openThroughDietOrder = true, // is true when open the Modal through the Dieat order and else false for the clinical care chart
  } = props;
  console.log("selectedRowselectedRowselectedRowselectedRow", selectedRow);
  const defaultValues = { date: new Date() };

  const schema = yup.object().shape({});

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    watch,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  const [postConfirmationModal, setPostConfirmationModal] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [patientInfo, setPatientinfo] = useState(null);
  const [selectedFeedRow, setSelectedFeedRow] = useState(null);
  const [scheduleFeedingData, setScheduleFeedingData] = useState([]);
  const [userAction, setUserAction] = useState([
    {
      id: 1,
      permission: "Feeded",
      isAction: true,
      menuId: null,
      functionalityId: null,
      menuKey: null,
    },
    {
      id: 2,
      permission: "Not Feeded",
      isAction: true,
      menuId: null,
      functionalityId: null,
      menuKey: null,
    },
  ]);
  console.log("selectedFeedRow", selectedFeedRow, openThroughDietOrder);

  const renderActions = (row, index) => {
    // Decide which value to check
    const actionValue = openThroughDietOrder ? row?.delivered : row?.given;
    // // Enable only when value is null
    // const isActionEnabled = actionValue === null;

    const isActionEnabled = openThroughDietOrder
      ? row?.delivered === null
      : row?.given === null && row?.delivered === true;
    return (
      <div className="flex gap-x-1 items-center py-[3px]">
        {userAction?.map((option) => {
          if (!option.isAction) return null;

          /* ================= APPROVE ================= */
          if (option.permission === "Feeded") {
            return isActionEnabled ? (
              <Tooltip
                key="approve"
                title={openThroughDietOrder ? "Delivered" : "Given"}
              >
                <button
                  type="button"
                  onClick={() => {
                    setSelectedFeedRow({
                      isApproveClick: true,
                      ...row,
                    });
                    setPostConfirmationModal(true);
                  }}
                >
                  <ApproveCheckIcon />
                </button>
              </Tooltip>
            ) : (
              <ApproveCheckIcon key="approve-disabled" disabled />
            );
          }

          /* ================= REJECT ================= */
          if (option.permission === "Not Feeded") {
            return isActionEnabled ? (
              <Tooltip
                key="reject"
                title={openThroughDietOrder ? "Not Delivered" : "Not Given"}
              >
                <button
                  type="button"
                  onClick={() => {
                    setSelectedFeedRow({
                      isApproveClick: false,
                      ...row,
                    });
                    setPostConfirmationModal(true);
                  }}
                >
                  <RejectIcon />
                </button>
              </Tooltip>
            ) : (
              <RejectIcon key="reject-disabled" disabled />
            );
          }

          return null;
        })}
      </div>
    );
  };
  const renderInput = (row, index, header) => {
    return <></>;
  };

  const getPatientRTFeedData = () => {
    getPatientRTFeedPlanByAddmissionId({
      admissionId: selectedRow?.admissionId || displayInfo?.AdmissionId,
    })
      .then((response) => response?.data)
      .then((res) => {
        setScheduleFeedingData(res?.result);
      })
      .catch((err) => {
        console.log(err);
        errorAlert(err?.message);
      });
  };
  const handleUpdateFeed = () => {
    setPostConfirmationModal(false);
    setOpenBackDrop(true);
    let postObj = {
      admissionId: selectedFeedRow?.admissionId,
      rtFeedDetailId: selectedFeedRow?.RTFeedsDetailId,
      delivered: openThroughDietOrder
        ? selectedFeedRow?.isApproveClick
          ? true
          : false
        : null,
      given: !openThroughDietOrder
        ? selectedFeedRow?.isApproveClick
          ? true
          : false
        : null,
      fromDiet: openThroughDietOrder ? true : false,
    };
    console.log("postObj", postObj, selectedFeedRow, openThroughDietOrder);
    updatePatientRTFeedStatus(postObj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          setOpenBackDrop(false);
          successAlert(res.message);
          setPostConfirmationModal(false);
          setSelectedFeedRow(null);
          if (openThroughDietOrder) {
            setSelectedRow(null);
          }
          getPatientRTFeedData();
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        setOpenBackDrop(false);
      });
  };
  console.log(
    "1071136107113610711361071136",
    selectedRow?.admissionId,
    displayInfo,
  );

  React.useEffect(() => {
    if (selectedRow !== null || displayInfo !== null) {
      console.log("selectedRow", selectedRow, displayInfo);

      setPatientinfo({
        "Patient Name":
          selectedRow?.patientName || displayInfo?.["Patient Name"],
        "Mr.No": selectedRow?.mrNo || displayInfo?.["MRNo"],
        Age: selectedRow?.age || displayInfo?.["AgeYear"],
        "Bed No": selectedRow?.bedNo || displayInfo?.["Bed No"],
        "Doctor Name": selectedRow?.doctorName || displayInfo?.["DoctorName"],
      });
    }
    getPatientRTFeedData();
  }, [selectedRow, displayInfo]);

  return (
    <Modal
      open={openRtFeedPatientModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={ModalStyle} className="w-[90%] max-h-[90%] overflow-y-auto ">
        <div className="flex justify-between  items-center mb-1">
          <h1 className=" font-semibold text-[17px]">Patient Feeding Chart</h1>
          <CloseModalIcon
            type={"button"}
            onClick={() => {
              setOpenRtFeedPatientModal(false);
              if (openThroughDietOrder) {
                setSelectedRow(null);
              }
              setSelectedFeedRow(null);
            }}
          />
        </div>
        <div className="">
          <CommonDivider color="#E0E0E0" />
        </div>
        {patientInfo !== null && (
          <div className="rounded-md shadow bg-[#ECF4FF] border border-[#8d96f5] p-2  my-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  text-sm">
              {Object.entries(patientInfo)?.map(([key, value]) => (
                <div
                  key={key}
                  className="grid  grid-cols-[40%_3%_56%] lg:grid-cols-[45%_3%_60%] xl:grid-cols-[32%_3%_65%]"
                  // className="flex items-center gap-x-2"
                >
                  <div className="font-semibold text-gray-600 whitespace-nowrap">
                    {key}
                  </div>

                  <div className="font-semibold text-[#073763]">:</div>

                  <div className="font-semibold text-[#073763] break-words">
                    {value || "-"}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div>
          {scheduleFeedingData.length > 0 ? (
            <CommonDynamicTableNew
              dataResult={scheduleFeedingData}
              highlightRow={false}
              tableClass="capitalize max-h-[400px]"
              renderActions={renderActions}
              renderInput={renderInput}
              editableColumns={["time"]}
              removeHeaders={[
                "id",
                "admissionId",
                "RTFeedsInfoId",
                "RTFeedsDetailId",
              ]}
            />
          ) : (
            <p className="py-12 text-center text-gray-600">
              No Feed Data Found<span className="animate-pulse">...</span>
            </p>
          )}
        </div>

        {postConfirmationModal && (
          <ConfirmationModal
            confirmationOpen={postConfirmationModal}
            confirmationHandleClose={() => {
              setPostConfirmationModal(false);
              setSelectedFeedRow(null);
            }}
            confirmationSubmitFunc={handleUpdateFeed}
            confirmationMsg={
              <>
                Confirm patient feed status mark as{" "}
                <strong
                  style={{
                    color: selectedFeedRow?.isApproveClick
                      ? "#2E7D32"
                      : "#D32F2F",
                  }}
                >
                  {selectedFeedRow?.isApproveClick
                    ? openThroughDietOrder
                      ? "Delivered"
                      : "Given"
                    : openThroughDietOrder
                      ? "Not Delivered"
                      : "Not Given"}
                </strong>
                ?
              </>
            }
            confirmationButtonMsg={"Confirm"}
            confirmationLabel={"Confirmation"}
          />
        )}
        {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
      </Box>
    </Modal>
  );
}

export default RTFeedPatientChartModal;
